module.exports = __webpack_public_path__ + "static/media/OnlineShop.76e7bb5b.jpg";